import styled from 'styled-components';
import { FaExternalLinkAlt } from 'react-icons/fa';

const CardShell = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.backgrounds.pure};
  border: ${({ theme }) => theme.borders.main};
  border-radius: 16px;
  overflow: hidden;
  box-shadow: ${({ theme }) => theme.boxShadow.main};
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.18);
  }
`;

const Banner = styled.div`
  position: relative;
  height: 180px;
  flex-shrink: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ $tint }) => $tint || 'transparent'};

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: ${({ $hasImage }) => $hasImage ?
      'linear-gradient(180deg, rgba(0, 19, 35, 0) 55%, rgba(0, 19, 35, 0.55) 100%)' :
      'none'
    };
    pointer-events: none;
  }
`;

const BannerImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: ${({ $position }) => $position || 'center'};
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  padding: 18px 20px 20px 20px;
  text-align: left;
`;

const Title = styled.div`
  color: ${({ theme }) => theme.colors.text};
  font-weight: 800;
  font-size: 20px;
`;

const Description = styled.div`
  color: ${({ theme }) => theme.colors.lightText};
  font-size: 14px;
  line-height: 1.5;
  flex: 1;
`;

const GradeChip = styled.div`
  align-self: flex-start;
  padding: 4px 12px;
  border-radius: 999px;
  background: rgba(127, 127, 127, 0.13);
  color: ${({ theme }) => theme.colors.text};
  font-size: 12px;
`;

const LaunchButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 10px;
  background: #009db7;
  color: #ffffff;
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 1px;
  text-transform: uppercase;
  cursor: pointer;

  &:hover {
    background: #008aa1;
  }
`;

const StatusLine = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  color: ${({ theme }) => theme.colors.lightText};
  font-size: 12px;
`;

const StatusDot = styled.span`
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #2ecc71;
  box-shadow: 0 0 0 3px rgba(46, 204, 113, 0.2);
`;

export default ({
  name,
  description,
  grades,
  image,
  imageAlt,
  imagePosition,
  icon,
  color,
  status,
  onLaunch
}) => {
  return (
    <CardShell>
      <Banner
        $hasImage={Boolean(image)}
        $tint={image ? undefined : `${color}18`}
      >
        {
          image ?
          <BannerImage src={image} alt={imageAlt || name} $position={imagePosition} />
          :
          icon
        }
      </Banner>
      <Body>
        <Title>{name}</Title>
        {
          Boolean(description) &&
          <Description>{description}</Description>
        }
        {
          Boolean(grades) &&
          <GradeChip>
            <b>{'Grades'}</b>{` ${grades}`}
          </GradeChip>
        }
        <LaunchButton onClick={onLaunch}>
          <FaExternalLinkAlt style={{ fontSize: '13px' }} />
          {'Launch Portal'}
        </LaunchButton>
        {
          Boolean(status) &&
          <StatusLine>
            <StatusDot />
            {status}
          </StatusLine>
        }
      </Body>
    </CardShell>
  )
}
